// extracted by mini-css-extract-plugin
export var card = "_my-1";
export var summary = "_my-0";